import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setCheapestCombinations } from '../../actions/date-select-actions';
import { makeGetCheapestCombination } from '../../selectors/cheapestDatesSelectors';

import type { State } from '../../selectors/types';

const getWeekendCombo = makeGetCheapestCombination();
const getLongWeekendCombo = makeGetCheapestCombination();
const getWeekCombo = makeGetCheapestCombination();
const getTwoWeekCombo = makeGetCheapestCombination();

export const useCheapestCombinationsDispatch = () => {
  const dispatch = useDispatch();

  const weekendCombo = useSelector((state: State) =>
    getWeekendCombo(state, 'weekend'),
  );
  const longWeekendCombo = useSelector((state: State) =>
    getLongWeekendCombo(state, 'longWeekend'),
  );
  const weekCombo = useSelector((state: State) => getWeekCombo(state, 7));
  const twoWeekCombo = useSelector((state: State) =>
    getTwoWeekCombo(state, 14),
  );

  const combosByDuration = useMemo(
    () => ({
      weekend: weekendCombo,
      longWeekend: longWeekendCombo,
      7: weekCombo,
      14: twoWeekCombo,
    }),
    [weekendCombo, longWeekendCombo, weekCombo, twoWeekCombo],
  );

  useEffect(() => {
    dispatch(setCheapestCombinations(combosByDuration));
  }, [dispatch, combosByDuration]);
};
